// extracted by mini-css-extract-plugin
export default {"setCollapse":"setCollapse___sy_MP","darkBlock":"darkBlock___ZxmWf"};